<template>
  <div>
    <b-breadcrumb :items="breadcrumb"></b-breadcrumb>
    <b-row class="mx-0 pb-5 border-bottom">
      <b-col class="col-12 col-md-4 text-center">
        <div class="d-flex">
          <div class="d-flex flex-column">
            <div
              style="width: 80px; cursor: pointer; max-height: 110px;"
              class="flex-fill m-1"
              v-if="images[1]"
              @click="bookData.imgCover = $store.state.user.siteData.location +
                'repository/books/' +
                $route.params.id +
                '_1'"
            >
              <img :src="$store.state.user.siteData.location +
                'repository/books/' +
                $route.params.id +
                '_1'" style="width: 100%; height: 100%;" />
            </div>
            <div
              style="width: 80px; cursor: pointer; max-height: 110px;"
              class="flex-fill m-1"
              v-if="images[2]"
              @click="bookData.imgCover = $store.state.user.siteData.location +
                'repository/books/' +
                $route.params.id +
                '_2'"
            >
              <img :src="$store.state.user.siteData.location +
                'repository/books/' +
                $route.params.id +
                '_2'" style="width: 100%; height: 100%;" />
            </div>
            <div
              style="width: 80px; cursor: pointer; max-height: 110px;"
              class="flex-fill m-1"
              v-if="images[3]"
              @click="bookData.imgCover = $store.state.user.siteData.location +
                'repository/books/' +
                $route.params.id +
                '_3'"
            >
              <img :src="$store.state.user.siteData.location +
                'repository/books/' +
                $route.params.id +
                '_3'" style="width: 100%; height: 100%;" />
            </div>
          </div>

          <div style="position: relative;">
            <transition name="fade">
              <div
                v-if="onFavs"
                style="
      position: absolute;
      z-index: 10;
      right: -2px;
      top: 50px;
      width: 35%;
      filter: drop-shadow(2px 4px .25rem rgba(0,0,0,.5));"
              >
                <img src="@/assets/favorite.svg" />
              </div>
            </transition>
            <img :src="calcBookData.imgCover" style="max-width: 100%;" />
            <img
              v-if="bookData.bookPrices[typeSel].promo"
              :src="$store.state.user.siteData.location +
                'repository/promos/' + bookData.bookPrices[typeSel].promo" 
              style="
                position: absolute;
                top: 0px;
                left: 0px;
                max-width: 100%;"      
              />
          </div>
        </div>
        <b-button
          class="mt-2 btn-text btn-block"
          variant="light"
          v-if="!onFavs"
          @click="addToFav()"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
            focusable="false"
            data-prefix="far"
            data-icon="heart"
            class="svg-inline--fa fa-heart fa-w-16"
            role="img"
            viewBox="0 0 512 512"
            width="1em"
            height="1em"
          >
            <path
              fill="currentColor"
              d="M458.4 64.3C400.6 15.7 311.3 23 256 79.3 200.7 23 111.4 15.6 53.6 64.3-21.6 127.6-10.6 230.8 43 285.5l175.4 178.7c10 10.2 23.4 15.9 37.6 15.9 14.3 0 27.6-5.6 37.6-15.8L469 285.6c53.5-54.7 64.7-157.9-10.6-221.3zm-23.6 187.5L259.4 430.5c-2.4 2.4-4.4 2.4-6.8 0L77.2 251.8c-36.5-37.2-43.9-107.6 7.3-150.7 38.9-32.7 98.9-27.8 136.5 10.5l35 35.7 35-35.7c37.8-38.5 97.8-43.2 136.5-10.6 51.1 43.1 43.5 113.9 7.3 150.8z"
            />
          </svg>
          Agregar a favoritos
        </b-button>
        <b-button
          class="mt-2 btn-text btn-block"
          v-if="onFavs"
          @click="removeFromFav()"
        >
          <font-awesome-icon icon="heart" class="mr-1" />Quitar de favoritos
        </b-button>
      </b-col>
      <b-col
        class="col-12 col-md-4 d-flex flex-column justify-content-between"
        style="font-family: 'Poppins', sans-serif;"
      >
        <div>
          <div
            style="font-weight: bolder; font-size: x-large; line-height: 1.1; margin-bottom: 10px;"
          >
            {{ calcBookData.bookTitle }}
          </div>
          <div
            style="font-family: 'Poppins', sans-serif; font-size: large; line-height: 1.5rem;"
          >
            {{ calcBookData.bookSubtitle }}
          </div>
          <div class="py-2 text-muted"><span v-html="calcBookData.bookDesc" /></div>
        </div>
        <div
          style="font-size: small; font-family: 'Nunito Sans', sans-serif; line-height: 1.7;"
        >
          <div v-if="calcBookData.publisher_name">
            <b>Editorial:</b> {{ calcBookData.publisher_name }}
          </div>
          <div v-if="calcBookData.category_name">
            <b>Temática:</b> {{ calcBookData.category_name }}
          </div>
          <div v-if="calcBookData.collection_name">
            <b>Colección:</b> {{ calcBookData.collection_name }}
          </div>
          <div v-if="calcBookData.props">
            <div v-if="calcBookData.props[1].ISBN">
              <b>ISBN:</b> {{ calcBookData.props[1].ISBN }}
            </div>
            <div v-if="calcBookData.props[1].Paginas">
              <b>Número de páginas:</b> {{ calcBookData.props[1].Paginas }}
            </div>
            <div v-if="calcBookData.props[1]['Fecha edicion']">
              <b>Año y mes de edición:</b> {{ calcBookData.props[1]['Fecha edicion'] }}
            </div>
            <div v-if="calcBookData.props[1].Formato">
              <b>Formato:</b> {{ calcBookData.props[1].Formato }}
            </div>
          </div>
        </div>
      </b-col>
      <b-col class="col-12 col-md-4">
        <div
          class="d-flex flex-column justify-content-center p-4 text-center"
          style="background: #F1F1F1; font-family: 'Poppins', sans-serif; border-radius: 2rem;"
        >
          <div style="font-weight: bolder; font-size: large;">Lo quiero</div>
          <b-form-radio-group id="radio-group-2" v-model="typeSel">
            <template v-for="(value, family) in bookData.bookPrices" >
              <div
                class="d-flex justify-content-between align-items-center p-2 border-bottom"
                :key="family"
                v-if="value.active === '1'"
              >
                <div style="width:40%; text-align: left; font-weight: 200;">
                  <span v-if="family === '1'">
                    Tapa blanda 
                  </span>
                  <span v-else-if="family === '2'">
                    Tapa dura 
                  </span>
                  <span v-else>
                    E-book 
                  </span>
                </div>
                <div v-if="getBooksByType(parseInt(family)) > 0" style="color: rgba(0,0,0,.7);">
                  <div
                    style="font-size: xx-small;margin: -4px 0px -.7rem;text-align: center;"
                  >
                    {{ getBooksByType(parseInt(family)) }}
                  </div>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    width="1rem"
                    height="1rem"
                  >
                    <path
                      id="svg_1"
                      fill="none"
                      d="m0,0l24,0l0,24l-24,0l0,-24z"
                    />
                    <path
                      id="svg_2"
                      d="m7.40705,18.67842c-1.1,0 -1.99,0.9 -1.99,2s0.89,2 1.99,2s2,-0.9 2,-2s-0.9,-2 -2,-2zm10,0c-1.1,0 -1.99,0.9 -1.99,2s0.89,2 1.99,2s2,-0.9 2,-2s-0.9,-2 -2,-2zm-9.83,-3.25l0.03,-0.12l0.9,-1.63l7.45,0c0.75,0 1.41,-0.41 1.75,-1.03l3.86,-7.01l-1.74,-0.96l-0.01,0l-1.1,2l-2.76,5l-7.02,0l-0.13,-0.27l-2.24,-4.73l-0.95,-2l-0.94,-2l-3.27,0l0,2l2,0l3.6,7.59l-1.35,2.45c-0.16,0.28 -0.25,0.61 -0.25,0.96c0,1.1 0.9,2 2,2l12,0l0,-2l-11.58,0c-0.13,0 -0.25,-0.11 -0.25,-0.25z"
                    />
                  </svg>
                </div>

                <b-form-radio :value="family" />
              </div>
            </template>            
          </b-form-radio-group>
          <div v-if="bookData.bookPrices[typeSel].stock > 0">
            <div class="my-3">
              <b-input-group style="margin-left: 30%; width: 40%;">
                <b-input-group-prepend>
                  <b-button @click="removeItem()">-</b-button>
                </b-input-group-prepend>

                <b-form-input
                  class="text-center bg-secondary text-white"
                  style="padding:0px; border-color: #6c757d;"
                  disabled
                  :value="onCart"
                ></b-form-input>

                <b-input-group-append>
                  <b-button @click="addItem()">+</b-button>
                </b-input-group-append>
              </b-input-group>
              <b-link style="color: black; font-size: 14px;" v-b-toggle.sidebar-cart
                >Ver carrito</b-link
              >
            </div>
            <div style="color: #62A202; font-size: small; font-weight: bold;">
              En Stock
            </div>
            <div style="font-size: xx-large; font-weight: bolder;">
              ${{ subtotal > 0 ? subtotal : cost }}
            </div>
            <div style="font-size: small;" v-if="subtotal > 0">
              ${{ cost }} x {{ onCart }}
            </div>
          </div>
          <div v-else>
            <div class="text-danger mt-3" style="font-size: small; font-weight: bold;">
              Sin Stock
            </div>
          </div>
        </div>
      </b-col>
    </b-row>
    <b-row class="mx-0 pb-5 border-bottom">
      <b-col cols="auto">
        <div class="d-flex">
          <img
            style="max-height: 200px; cursor: pointer;"
            :src="$store.state.user.siteData.location +
                'repository/combos/' +
                $route.params.id"
            @click="bookSel = null"
          />
          <!--
          <img
            style="max-height: 200px; cursor: pointer;"
            v-for="(includeBook, index) in bookData.includeBooks"
            :key="'includebook-' + includeBook.id"
            :src="$store.state.user.siteData.location +
                'repository/books/' +
                includeBook.id + '_1'"
            @click="bookSel = index"
          />
          -->          
        </div>
      </b-col>
      <b-col>
        <CoverSpiner :items="bookData.includeBooks" @selbook="bookSel = $event" />
      </b-col>
    </b-row>
    <b-row class="mx-0 pb-5 border-bottom">
      <b-col class="col-12 col-md-8">
        <main-title title="Detalle del combo" />
        <div
          style="font-size: small; overflow: auto; max-height: 270px; padding:0.25rem 1rem 0.25rem 0px; font-weight: 300;"
        >
          <span v-html="bookData.bookResume"></span>
        </div>
      </b-col>
    </b-row>
    <main-title :title="authorTitle" />
    <div class="d-flex align-items-start mb-4 flex-wrap">
      <div
        class="d-flex flex-column align-items-center mx-2 my-4"
        v-for="authorData in bookData.authorsData"
        :key="authorData.id"
        style="width: 165px; text-align: center;"
        @click="viewAuthor(authorData.id)"
      >
        <b-avatar class="d-inline-flex" size="150px" :src="$store.state.user.siteData.location +
                'repository/authors/' + authorData.id  + '_small'" />
        <span class="mt-2">{{ authorData.name }}</span>
      </div>
    </div>
    

    <main-title :title="relatedAuthorTitle" />
    <book-list :items="relatedAuthorBooks" @selbook="updateData()" />
    <main-title title="También te puede interesar" />
    <book-list :items="relatedCategoryBooks" @selbook="updateData()" />
    <!--
    <main-title title="Notas relacionadas" />
    <div class="d-flex" style="margin: 0px -1rem;">
      <small-news></small-news>
      <small-news></small-news>
      <small-news></small-news>
    </div>
    -->
  </div>
</template>
<script>
import { mapActions } from "vuex";
import MainTitle from "@/components/MainTitle.vue";
import BookList from "@/components/BookList.vue";
import SmallNews from "@/components/Noticias/Small.vue";
import CoverSpiner from "@/components/CoverSpiner.vue";
import axios from "axios";

export default {
  components: {
    MainTitle,
    BookList,
    SmallNews,
    CoverSpiner
  },
  data: function() {
    return {
      breadcrumb: [
        {
          text: "Libreria",
          to: { name: "Libreria" }
        },
        {
          text: "Combos",
          to: { name: "Libreria" }
        },
        {
          text: "Comunicación y periodismo",
          active: true
        }
      ],
      typeSel: "5",
      cost: 700,
      subtotal: 0,
      bookData: {},
      bookProps:{
        publisher: '',
        collection: '',
        category: '',
        ISBN: '',
        pages: '',
        dateedition: '',
        format: ''
      },
      documents: [],
      images: [
        false,
        false,
        false,
        false
      ],
      authorTitle: 'Sobre los autores',
      relatedAuthorTitle: 'Otros libros de los autores',
      relatedAuthorBooks: [],
      relatedCategoryBooks: [],
      authorBios: [],
      authorNames: [],
      bookSel: null
    };
  },
  mounted(){
    this.updateBookInfo();
    this.getDocuments();
  },
  computed: {
    onFavs: function() {
      const favBookIndex = this.$store.getters.getFavItemByType(
        { id: this.bookData.bookId, type: 5 }
      );
      if (favBookIndex === 0) {
        return false;
      } else {
        return true;
      }
    },
    /*
    bookData: function() {
      return {
        imgCover: "img/7.png",
        bookTitle: "Comunicación y periodismo",
        bookDesc: "Sivana Comba y Edgardo Toledo",
        bookId: parseInt(this.$route.params.id),
        size: 25
      };
    },
    */
    onCart: function() {
      return this.$store.getters.getItemByType({
        id: this.bookData.bookId,
        type: parseInt(this.typeSel)
      });
    },
    demo: function() {
      const result = [];
      for (let page = 0; page < 2; page++) {
        for (let bookData = 1; bookData < 5; bookData++) {
          result.push({
            imgCover: "img/7.png",
            bookTitle: "Comunicación y periodismo",
            bookDesc: "Sivana Comba y Edgardo Toledo",
            bookId: bookData + page * 4,
            size: 25
          });
        }
      }
      return result;
    },
    calcBookData: function() {
      if (this.bookSel === null) {
        return this.bookData;
      } else {
        return this.bookData.includeBooks[this.bookSel]
      }
    }
  },
  watch: {
    typeSel: function(newValue, oldValue) {
      
      this.cost = parseInt(this.bookData.bookPrices[newValue].price);
      this.bookProps.ISBN = this.bookData.bookProperties[newValue].ISBN;
      this.bookProps.pages = this.bookData.bookProperties[newValue].Paginas;
      this.bookProps.dateedition = this.bookData.bookProperties[newValue]['Fecha edicion'];
      this.bookProps.format = this.bookData.bookProperties[newValue].Formato;

      if (this.onCart > 0) {
        this.subtotal = this.onCart * this.cost;
      }
    },
    onCart: function(newValue, oldValue) {
      this.subtotal = newValue * this.cost;
    }
  },
  created: function() {
    if (this.onCart > 0) {
      this.subtotal = this.onCart * this.cost;
    }
  },
  methods: {
    updateData(){
      console.log('Actualizar');
      this.updateBookInfo();
      this.getDocuments();
    },
    async updateBookInfo(){
      console.log(this.$store.state.user.siteData);

      await axios
        .post(
          this.$store.state.user.siteData.location + "items/combos/getDetails",
          JSON.stringify( {id: this.$route.params.id } ),
          {
            validateStatus(status) {
              return status < 500; // Resolve only if the status code is less than 500
            },
            headers: {
              "Content-Type": "application/json"
            }
          }
        )
        .then(evtResponse => {
          console.log(evtResponse.data);
          let result = {};
          evtResponse.data.records.forEach(element => {
            result = {
              imgCover:
                this.$store.state.user.siteData.location +
                "repository/combos/" +
                element.id,
              bookTitle: element.name,
              bookDesc: element.resume,
              bookId: parseInt(element.id),
              bookResume: element.resume,
              bookSubtitle: '',
              bookPrices: { 5: { active: 1, price: element.price, regularprice: element.price, promo: null, stock: 1 } },
              bookProperties: {},
              authorIds: [],
              authorsData: [],
              categoryID: null,
              categoryList: [],
              category: '',
              size: 25,
              includeBooks: element.books
            };
            this.breadcrumb[2].text = element.name;
            const bookTitles = [];
            const bookCategory = [];
            element.books.forEach((includeBook, includeBookIndex) => {
              bookTitles.push('<li>' + includeBook.title + '</li>')
              bookCategory.push(includeBook.category_name)
              result.includeBooks[includeBookIndex].imgCover = this.$store.state.user.siteData.location +
                "repository/books/" +
                includeBook.id + '_' + includeBook.img;
              result.includeBooks[includeBookIndex].bookTitle = includeBook.title;
              result.includeBooks[includeBookIndex].bookSubtitle = includeBook.subtitle;
              if (includeBook.category_ids !== null) {
                result.categoryList = result.categoryList.concat(includeBook.category_ids.split(','));
              }
              const bookAuthorsNames = []
              includeBook.authors.forEach((includeBookAuthor) => {
                if (!result.authorIds.includes(includeBookAuthor.id)){
                  result.authorIds.push(includeBookAuthor.id)
                  bookAuthorsNames.push(includeBookAuthor.name)
                  result.authorsData.push({
                    id: includeBookAuthor.id,
                    name: includeBookAuthor.name
                  })
                }
              })
              // result.authorsData = result.authorsData.concat(includeBook.authors)
              result.includeBooks[includeBookIndex].bookDesc =  bookAuthorsNames.join(', ');
            })
            // result.bookDesc = bookTitles.join(', ')
            result.bookDesc = '<ul>' + bookTitles.join('') + '</ul>';
            result.category = bookCategory.join(', ')
            this.cost = parseInt(element.price);
            /*
            this.authorBios = element.authorBio;
            this.authorNames = element.author.split(', ');

            this.bookProps.publisher = element.publisher_name;
            this.bookProps.collection = element.collection_name;
            this.bookProps.category = element.category_name;

            for(let p=1; p < 4; p ++){
              if (element.price[p].active === '1'){
                this.cost = parseInt(element.price[p].price);
                this.bookProps.ISBN = element.props[p].ISBN;
                this.bookProps.pages = element.props[p].Paginas;
                this.bookProps.dateedition = element.props[p]['Fecha edicion'];
                this.bookProps.format = element.props[p].Formato;

                break;
              }
            }
            */
          });
          this.bookData = result;

          /*
          this.getBookImages(1);
          */
         this.getRelatedBooks();
          
          
        });
    },
    async getDocuments(){
      console.log(this.$store.state.user.siteData);

      this.documents = await axios
        .post(
          this.$store.state.user.siteData.location + "documents/documents/find",
          JSON.stringify( {entitytype: 'items', entityid: this.$route.params.id } ),
          {
            validateStatus(status) {
              return status < 500; // Resolve only if the status code is less than 500
            },
            headers: {
              "Content-Type": "application/json"
            }
          }
        )
        .then(evtResponse => {
          console.log(evtResponse.data);
          const result = [];
          evtResponse.data.records.forEach(element => {
            result.push( {
              name: element.name,
              id: element.id,
              downloable: element.downloable
            });
            
          });
          return result;
        });
    },
    download(document) {
      window.open(
        this.$store.state.user.siteData.location + 'repository/documents/' + document.id
      )
    },
    async getRelatedBooks(){
      
      this.relatedAuthorBooks = await axios
        .post(
          this.$store.state.user.siteData.location + "items/books/getForStore",
          JSON.stringify({ page: 1, author: this.bookData.authorIds }),
          {
            validateStatus(status) {
              return status < 500; // Resolve only if the status code is less than 500
            },
            headers: {
              "Content-Type": "application/json"
            }
          }
        )
        .then(evtResponse => {
          console.log(evtResponse.data);
          const result = [];
          evtResponse.data.records.forEach(element => {
            result.push({
              imgCover:
                this.$store.state.user.siteData.location +
                "repository/books/" +
                element.id +
                "_" +
                element.img,
              bookTitle: element.title,
              bookDesc: element.author,
              bookId: parseInt(element.id),
              bookResume: element.resume,
              bookSubtitle: element.subtitle,
              bookPrice: parseInt(element.price),
              regularCost: parseInt(element.regularcost),
              bookStock: parseInt(element.stock),
              size: 33,
              promo: element.promo
            });
          });
          return result;
        });
      this.relatedCategoryBooks = await axios
        .post(
          this.$store.state.user.siteData.location + "items/books/getForStore",
          JSON.stringify({ page: 1, category: this.bookData.categoryList }),
          {
            validateStatus(status) {
              return status < 500; // Resolve only if the status code is less than 500
            },
            headers: {
              "Content-Type": "application/json"
            }
          }
        )
        .then(evtResponse => {
          console.log(evtResponse.data);
          const result = [];
          evtResponse.data.records.forEach(element => {
            result.push({
              imgCover:
                this.$store.state.user.siteData.location +
                "repository/books/" +
                element.id +
                "_" +
                element.img,
              bookTitle: element.title,
              bookDesc: element.author,
              bookId: parseInt(element.id),
              bookResume: element.resume,
              bookSubtitle: element.subtitle,
              bookPrice: parseInt(element.price),
              regularCost: parseInt(element.regularcost),
              bookStock: parseInt(element.stock),
              size: 33,
              promo: element.promo
            });
          });
          return result;
        });
    },
    getBookImages: function(image){
      const imgRepo = this.$store.state.user.siteData.location +
                'repository/books/' +
                this.$route.params.id  +
                '_' + image;
      const tmpimg = new Image();
      tmpimg.onload = function(){
        this.images[image] = true;
        this.images = this.images.slice(0);

        if (image < 3){
          console.log('Load ' + (image + 1) +' on load');
          this.getBookImages(image + 1);
        }
      }.bind(this);
      tmpimg.onerror = function(){
        if (image < 3){
          console.log('Load ' + (image + 1) +' on error');
          this.getBookImages(image + 1);
        }
      }.bind(this);
      tmpimg.src = imgRepo;

    },
    getBooksByType: function(type) {
      return this.$store.getters.getItemByType({
        id: this.bookData.bookId,
        type: type
      });
    },
    addToFav: function() {
      this.addFavItem({id: this.bookData.bookId, type: 5});
    },
    removeFromFav: function() {
      this.removeFavItem({id: this.bookData.bookId, type: 5});
    },
    addItem: function() {
      this.addCartItem({
        id: this.bookData.bookId,
        type: parseInt(this.typeSel)
      });
    },
    removeItem: function() {
      this.removeCartItem({
        id: this.bookData.bookId,
        type: parseInt(this.typeSel)
      });
    },
    viewAuthor(autorId){
      this.$router.push({name: 'AutoresDetail', params: {id: autorId} });
    },
    ...mapActions([
      "addCartItem",
      "removeCartItem",
      "addFavItem",
      "removeFavItem"
    ])
  }
};
</script>
